import {
  Directive,
  ElementRef,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { MotionService } from '@app/services/motion.service';

type AnimationType = 'viewEnter' | 'viewLeave' | 'scaleIn' | 'slideUp' | 'fadeIn' | 'staggerIn';

@Directive({
  selector: '[appMotionAnimate]',
  standalone: false,
})
export class MotionAnimateDirective implements OnInit, OnDestroy {
  private readonly el = inject(ElementRef);
  private readonly motionService = inject(MotionService);

  @Input('appMotionAnimate') animationType: AnimationType = 'viewEnter';
  @Input() motionDuration = 0.6;
  @Input() motionDelay = 0;
  @Output() animationComplete = new EventEmitter<void>();

  private animationPromise: Promise<void> | null = null;

  ngOnInit(): void {
    this.animate();
  }

  ngOnDestroy(): void {
    if (this.animationPromise) {
      this.animationPromise = null;
    }
  }

  private animate(): void {
    const element = this.el.nativeElement as HTMLElement;

    switch (this.animationType) {
      case 'viewEnter':
        this.animationPromise = this.motionService.viewEnter(
          element,
          this.motionDuration
        );
        break;
      case 'viewLeave':
        this.animationPromise = this.motionService.viewLeave(
          element,
          this.motionDuration
        );
        break;
      case 'scaleIn':
        this.animationPromise = this.motionService.scaleIn(
          element,
          this.motionDuration
        );
        break;
      case 'slideUp':
        this.animationPromise = this.motionService.slideUp(
          element,
          this.motionDuration,
          this.motionDelay
        );
        break;
      case 'fadeIn':
        this.animationPromise = this.motionService.fadeIn(
          element,
          this.motionDuration,
          this.motionDelay
        );
        break;
    }

    if (this.animationPromise) {
      this.animationPromise.then(() => {
        this.animationComplete.emit();
      });
    }
  }
}
